'use client'

import Button from '../Button'
import Modal from '../Modal'
import { useState } from 'react'

const SignUpButton = () => {
  const [signupIsOpen, setSignupIsOpen] = useState(false)

  return (
    <>
      <Button onClick={() => setSignupIsOpen(true)}>
        Create account to get access
      </Button>
      <Modal open={signupIsOpen} onOpenChange={setSignupIsOpen}>
        <Modal.Content title="Coming Soon">
          <p className="text-center">
            This functionality is currently disabled as we are in our beta phase.
            We appreciate your understanding and continue to improve
          </p>
        </Modal.Content>
      </Modal>
    </>
  )
}

export default SignUpButton
